// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rewards-popover-container,
.rewards-popover-section {
  color: #59606D;
}
.rewards-popover-container .focusable:focus,
.rewards-popover-section .focusable:focus {
  text-decoration: underline;
}
.redeem-section h4 {
  margin: -2px 0 12px;
  font-size: 18px;
  line-height: 1;
  font-weight: 600;
  color: #59606D;
}
@media screen and (max-width: 735px) {
  .rewards-drawer .ant-drawer-body {
    padding-top: 0;
  }
}
.rewards-section .rewards-header {
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
}
.rewards-section .rewards-header .gift-code-callout-header {
  color: #59606D;
  margin-left: 3px;
}
@media screen and (max-width: 735px) {
  .rewards-section .rewards-header .gift-code-callout-header {
    font-size: 16px;
    line-height: 24px;
  }
}
.rewards-section .balance {
  color: black;
}
.rewards-section .ant-divider {
  margin: 16px 0;
  border-top: 1px solid #C9D1DF;
}
.rewards-section .reward-gift-icon {
  width: 22px;
  height: 20px;
}
.rewards-section .gift-code-callout p {
  margin: 10px 0;
}
.rewards-section .gift-code-callout.gift-code-callout-secondary p {
  margin-top: 0;
}
.rewards-section .gift-code-callout-reward {
  margin-bottom: 24px;
}
.rewards-section .gift-code-callout-reward .congrats-header {
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: black;
}
.rewards-section .gift-code-callout-reward .gift-code-text {
  margin-bottom: 10px;
}
.rewards-section .gift-code-callout-reward .anticon {
  width: 16px;
  vertical-align: baseline;
  fill: currentColor;
}
.rewards-section .gift-code-callout-reward .deck-redeem-btn {
  float: none;
  padding: 5px 12px !important;
  font-size: 12px;
  line-height: 12px;
  font-weight: 600;
  height: 26px;
  border-color: unset;
  box-shadow: none;
  text-shadow: none;
  display: inline-block;
}
.rewards-section .gift-code-callout-reward .deck-redeem-btn.is-disabled {
  cursor: not-allowed;
}
.rewards-section .gift-code-callout-reward .deck-redeem-btn .gift-code-redeem-link:hover {
  color: unset;
}
.rewards-section .gift-code-callout-reward .nkl-tag {
  margin-right: 0;
}
.rewards-section .gift-code-expiration {
  margin-right: 10px;
  margin-left: 10px;
}
.rewards-section .gift-code-expiration strong {
  font-size: 16px;
}
.rewards-section .nkl-points-display {
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: #59606D;
  display: flex;
  align-items: baseline;
}
.rewards-section .nkl-points-display .points-amount {
  font-size: 38px;
  font-weight: 700;
  margin-right: 6px;
  line-height: 52px;
}
@media screen and (max-width: 735px) {
  .rewards-section .nkl-points-display .points-amount {
    font-size: 30px;
    line-height: 40px;
  }
}
.rewards-section .nkl-points-display .points-label {
  text-transform: capitalize;
}
@media screen and (max-width: 735px) {
  .rewards-section .nkl-points-display .points-label {
    font-size: 18px;
    line-height: 28px;
  }
}
.rewards-section .nkl-account-display {
  margin-top: 24px;
  margin-bottom: 14px;
}
.rewards-section .nkl-account-display p {
  margin-bottom: 0;
}
.rewards-section .nkl-account-display.nkl-account-no-gift-codes {
  margin-top: 0;
}
.redeem-menu,
.arcade-menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.redeem-menu .redeem-option,
.arcade-menu .redeem-option {
  flex-basis: auto;
  padding: 0;
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
}
.redeem-menu .market-link,
.arcade-menu .market-link {
  display: block;
  cursor: pointer;
  width: 100%;
}
.redeem-menu .market-link:hover,
.arcade-menu .market-link:hover,
.redeem-menu .market-link:focus,
.arcade-menu .market-link:focus {
  text-decoration: none;
}
.redeem-menu .market-link:hover .link-label,
.arcade-menu .market-link:hover .link-label,
.redeem-menu .market-link:focus .link-label,
.arcade-menu .market-link:focus .link-label {
  background-color: #F5F7FA;
  border-radius: 8px;
}
.redeem-menu .market-link.is-disabled,
.arcade-menu .market-link.is-disabled {
  cursor: not-allowed;
}
.redeem-menu .icon,
.arcade-menu .icon {
  position: relative;
  width: 18px;
  height: 18px;
  margin: 0 8px 0 4px;
}
.redeem-menu svg,
.arcade-menu svg {
  position: absolute;
  top: 0;
  width: 100%;
}
@media screen and (max-width: 735px) {
  .redeem-menu svg,
  .arcade-menu svg {
    width: auto;
  }
}
.redeem-menu .link-label,
.arcade-menu .link-label {
  display: flex;
  align-items: center;
  flex-basis: auto;
  width: 100%;
  height: 100%;
  margin-top: 10px / 2;
  padding: 14px;
  color: #000;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  pointer-events: none;
}
@media screen and (max-width: 735px) {
  .redeem-menu .link-label,
  .arcade-menu .link-label {
    padding: 0;
    padding-left: 8px;
    padding-right: 8px;
  }
}
.redeem-menu .link-label .rewards-store-description,
.arcade-menu .link-label .rewards-store-description {
  display: flex;
  flex-direction: column;
  align-self: start;
  max-width: 265px;
}
.redeem-menu .link-label img,
.arcade-menu .link-label img {
  height: 44px;
  margin-right: 10px;
  align-self: start;
}
.redeem-menu .link-label .link-text,
.arcade-menu .link-label .link-text {
  font-size: 16px;
  font-weight: 600;
  color: black;
  margin-bottom: 2px;
  line-height: 24px;
}
@media screen and (max-width: 735px) {
  .redeem-menu .link-label .link-text,
  .arcade-menu .link-label .link-text {
    font-size: 14px;
    line-height: 20px;
  }
}
.redeem-menu .link-label .sub-text,
.arcade-menu .link-label .sub-text {
  font-size: 14px;
  font-weight: 400;
  color: #59606D;
  line-height: 20px;
}
@media screen and (max-width: 735px) {
  .redeem-menu .link-label .sub-text,
  .arcade-menu .link-label .sub-text {
    font-size: 12px;
    line-height: 16px;
  }
}
.redeem-menu .deck-external-link-icon,
.arcade-menu .deck-external-link-icon {
  position: relative;
  width: 24px;
  height: 24px;
  margin-left: auto;
  color: #59606D;
}
@media screen and (max-width: 735px) {
  .redeem-menu .deck-external-link-icon,
  .arcade-menu .deck-external-link-icon {
    height: 100%;
    top: 8px;
  }
}
#deck-rewardsPopoverContainer .ant-popover-inner-content {
  padding: 0;
  width: auto;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
